import React from "react";
import { AppConfig } from "@launchos/modules/app";
import AvatarButton from "../../settings/AvatarButton";

export const AvatarMenu: React.FC = () => (
  <AppConfig.Consumer>
    {({ app }) => app.showAvatar && <AvatarButton />}
  </AppConfig.Consumer>
);
